import { render, staticRenderFns } from "./CourseBuilderISpringQuizForm.vue?vue&type=template&id=7fe0bceb&scoped=true&"
import script from "./CourseBuilderISpringQuizForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderISpringQuizForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderISpringQuizForm.vue?vue&type=style&index=0&id=7fe0bceb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe0bceb",
  null
  
)

export default component.exports